interface TimelineItemLike {
  time: string;
  actor: string;
  type: string;
  title: string;
  content: string;
  source: string;
}

interface TimelineNodeProps {
  item: TimelineItemLike;
  isLast: boolean;
}

const typeStyles: Record<string, { badge: string; dot: string }> = {
  传言: { badge: "bg-background-200 text-foreground-700 border-background-300", dot: "bg-foreground-400" },
  回应: { badge: "bg-secondary-100 text-secondary-900 border-secondary-200", dot: "bg-secondary-500" },
  通报: { badge: "bg-primary-100 text-primary-800 border-primary-300", dot: "bg-primary-500" },
  辟谣: { badge: "bg-accent-100 text-accent-800 border-accent-300", dot: "bg-accent-500" },
  进展: { badge: "bg-background-100 text-foreground-700 border-background-300", dot: "bg-foreground-500" },
};

export default function TimelineNode({ item, isLast }: TimelineNodeProps) {
  const style = typeStyles[item.type] || typeStyles["进展"];
  return (
    <li className="relative pl-8 pb-8 last:pb-0">
      {!isLast && <span className="absolute left-[7px] top-4 bottom-0 w-px bg-background-300"></span>}
      <span className={`absolute left-0 top-1.5 h-3.5 w-3.5 rounded-full border-2 border-background-50 ${style.dot}`}></span>

      <div className="flex flex-wrap items-center gap-3">
        <time className="font-heading text-sm font-bold text-foreground-950">{item.time}</time>
        <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${style.badge}`}>
          {item.type}
        </span>
        <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
          <span className="flex h-3.5 w-3.5 items-center justify-center">
            <i className="ri-verified-badge-line"></i>
          </span>
          {item.actor}
        </span>
      </div>

      <h3 className="mt-2.5 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
      <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.content}</p>
      <p className="mt-3 inline-flex items-center gap-1.5 rounded-md bg-background-100 px-3 py-1.5 text-xs text-foreground-500">
        <span className="flex h-3.5 w-3.5 items-center justify-center">
          <i className="ri-link"></i>
        </span>
        来源类型：{item.source}
      </p>
    </li>
  );
}